<template>
    <div v-if="filtro" class="modal show" id="ExclusaoPessoas" tabindex="-1" role="dialog" :aria-labelledby="'ExclusaoPessoasLabel'" aria-hidden="true" @click.self="fechar()">
        <div class="modal-dialog  modal-dialog-centered" role="document">
            <div class="modal-content">
                <div class="modal-header">
                    <h5 class="modal-title" id="ExclusaoPessoasLabel">
                        <b-icon icon="exclamation-triangle-fill" class="text-danger mr-1" aria-hidden="true"></b-icon>
                        Excluir filtro
                    </h5>
                </div>
                <!-- semPadding mantido por compatibilidade: as duas variantes agora têm o mesmo corpo -->
                <div class="modal-body">
                    <div class="alert alert-success text-center" role="alert" v-if="filtroExcluido.status=='OK'">
                        {{ filtroExcluido.mensagem }}
                    </div>
                    <div class="alert alert-danger text-center" role="alert" v-if="filtroExcluido.status=='NOK'">
                        {{ filtroExcluido.mensagem }}
                    </div>

                    <template v-if="filtro.anoliberacaoinscricaocursoweb">
                        <p v-if="!filtroExcluido.status" class="ec-exclusao__aviso">
                            Você está prestes a excluir o filtro abaixo. Depois de excluído, ele deixa de ser aplicado e não pode ser recuperado por esta tela.
                        </p>

                        <dl class="ec-exclusao__ficha">
                            <dt>Ano inscrição</dt>
                            <dd>{{ filtro.anoliberacaoinscricaocursoweb }}</dd>
                            <dt>Curso</dt>
                            <dd>{{ filtro.nomecurso || '—' }}</dd>
                            <dt>Período</dt>
                            <dd v-if="filtro.semestre==0">Anual</dd>
                            <dd v-else-if="filtro.semestre==1">1º Semestre</dd>
                            <dd v-else-if="filtro.semestre==2">2º Semestre</dd>
                            <dd v-else>Todos</dd>
                            <template v-if="filtro.datainicio">
                                <dt>Data início</dt>
                                <dd>{{ formatDate(filtro.datainicio,2) }}</dd>
                            </template>
                            <template v-if="filtro.datatermino">
                                <dt>Data término</dt>
                                <dd>{{ formatDate(filtro.datatermino,2) }}</dd>
                            </template>
                        </dl>
                    </template>
                </div>
                <div class="modal-footer">
                    <button v-if="!filtroExcluido.status" type="button" class="btn btn-danger" :id="'btnOkExclusaoFiltros'" @click="excluirFiltro(filtro)"><b-icon icon="trash-fill" aria-hidden="true"></b-icon> Excluir</button>
                    <button type="button" class="btn btn-secondary" data-dismiss="modal" :id="'Fechar'" @click="fechar()">Fechar</button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    props:{
        urlRedirect:{type:String, requied:true},
        filtro:{type:Object, requied:false},
        urlSistema:{type:String, requied:true},
        semPadding:{type:Boolean,required:false}
        
    },
    
    data(){
        return {
            filtroSelecionado:{},
            filtroExcluido:{},
        }
    },
    created(){
         this.filtroSelecionado = this.filtro
    },
    methods:{
        redirect(){
            window.location.href = this.urlRedirect;
        },
        fechar(){
            this.filtroExcluido = {}
        },
        excluirFiltro(filtro){
            console.log('/api/v1'+this.urlSistema+'/'+filtro.id);
            var config = {
            method: 'delete',
            url: '/api/v1'+this.urlSistema+'/'+filtro.id,
            // headers: {
            //         'Accept': 'application/json',
            //         'Authorization': this.$root.token(),
            //     },
            };
            //executa requisição
            axios(config)
            .then(response => {

                this.filtroExcluido = response.data;
                console.log('Exclusai',this.filtroExcluido);
                this.$emit('exclusaoconcluida' /*, this.nclick*/);
                
            })
            .catch(error => {
                console.log(error);
            });

            $("#ExclusaoFiltro").modal('');
        },
        formatDate(date,idioma) {
            var d = new Date(date),
                month = '' + (d.getMonth() + 1),
                day = '' + d.getDate(),
                year = d.getFullYear();

            if (month.length < 2) 
                month = '0' + month;
            if (day.length < 2) 
                day = '0' + day;

            if(idioma==1){
                return [year, month, day].join('-');
            }else if(idioma==2){
                return [day, month, year].join('/');
            }else{
                return [year, month, day].join('-');
            }
        },
        
    }
}
</script>

<style scoped>
    /* resumo do registro a excluir: rótulo à esquerda, valor à direita (empilha no celular) */
    .ec-exclusao__aviso {
        margin-bottom: .85rem;
        color: #b42318;
        font-size: .875rem;
    }

    .ec-exclusao__ficha {
        display: grid;
        grid-template-columns: max-content 1fr;
        gap: .45rem 1rem;
        margin: 0;
        padding: .75rem 1rem;
        background: #f8fafb;
        border: 1px solid #e3e9ed;
        border-radius: .5rem;
        text-align: left;
    }

    .ec-exclusao__ficha dt {
        align-self: center;
        font-size: .68rem;
        font-weight: 700;
        letter-spacing: .04em;
        text-transform: uppercase;
        color: #64767c;
    }

    .ec-exclusao__ficha dd {
        margin: 0;
        font-weight: 600;
        overflow-wrap: anywhere;
        font-variant-numeric: tabular-nums;
    }

    @media (max-width: 575.98px) {
        .ec-exclusao__ficha { grid-template-columns: 1fr; gap: .1rem; }
        .ec-exclusao__ficha dd { margin-bottom: .5rem; }
        .ec-exclusao__ficha dd:last-child { margin-bottom: 0; }
    }
</style>
